import { render, staticRenderFns } from "./EditionsComparison.vue?vue&type=template&id=02b3d996&scoped=true"
import script from "./EditionsComparison.vue?vue&type=script&lang=js"
export * from "./EditionsComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b3d996",
  null
  
)

export default component.exports